import $ from "jquery"
/*
# This is a widget that makes "1 days ago", "1 years ago" etc from date object.
# It is a modification from John Resig"s little plugin.
# Hence the original copyright and license notice:
#
#
#  * JavaScript Pretty Date
#  * Copyright (c) 2011 John Resig (ejohn.org)
#  * Licensed under the MIT and GPL licenses.
#
#
# We redistribute it to users under MIT license.
#
# Original script: http://ejohn.org/blog/javascript-pretty-date/
#
# The biggest changes from the original file here is perhaps we have added
# multi-language support.
#
# We have some code in Ruby which do this, but as all the market news are
# fetched with AJAX on client side, formatted on client side, we cannot make
# use of these existing code, sadly.
#
# This plugin doesn"t do exactly what Rails" function is doing, but at the
# moment it seems to be enough to get things working.
#
# To make sure this plugin is reusable, scalable and won"t break in future,
# this plugin uses translation strings from config/locales/, instead of
# hard-coding a new set of translation strings here: all translation should
# be managed and changed at the same place and same function: config/locales
# and the t() function.
#
# So to use this plugin, one MUST do
#
# HAML:
#
#     .mydate{ data-translation-just-now: t(...),
#              data-translation-1mins-ago: t(...),
#              ...,
#              title: "2016-02-25T06:38:35+00:00" }
#
# Coffeescript:
#
#     $(".mydate").prettierDate()
#
# In prettierDate(), it reads from data attributes the translation of stuff.
# This way, when we add another new language, the plugin doesn"t break, nor
# do we need to scatter shitty translation strings around files.
#
# Oh, the HAML seems troublesome to write everytime I want to use the date.
# So there is a concept cell for the HAML part.
#
# What you will actually do to use this, include the concept cell, and call
# $(".mydate").prettierDate(). That"s it.
*/

// Local helper.
// Interpolate a string of style "hello %{foobar}".
const rb_interpolate = (str: string, substitution: {[key: string]: string | number} = {}) =>
  str.replace(/%{(.+?)}/g, (_match, key) => substitution[key].toString())

const prettierDate = (time: string, jq_elem: JQuery) => {
  /*
  # Local helper just for convenience, use it like as if in Rails:
  #
  #   t("x_minutes", count: 2)
  #
  # Plus, you can chain up with ago():
  #   t("x_minutes", count:2).ago()
  #
  # which does exactly what you would expected
  */
  const t = (word_id: string, substitution?: {[key: string]: string | number}) => {
    let translation = jq_elem.data(word_id)
    translation = rb_interpolate(translation, substitution)
    translation.ago = () =>
      rb_interpolate(jq_elem.data("ago"), {time_span: translation})
    return translation
  }

  // date = new Date((time or "").replace(/-/g, "/").replace(/[TZ]/g, " "))
  const date = new Date(time || "")
  const diff = ((new Date()).getTime() - date.getTime()) / 1000
  const day_diff = Math.floor(diff / 86400)

  // TODO: day_diff > 31 shouldn"t be there
  if (isNaN(day_diff) || day_diff < 0 || day_diff >= 31) { return }

  if (day_diff === 0){
    return (diff < 60 && t("half-a-minute").ago()) ||
      (diff < 120 && t("x-minutes-one").ago()) ||
      (diff < 3600 && t("x-minutes-other", {count: Math.floor(diff / 60)}).ago()) ||
      (diff < 7200 && t("x-hours-one").ago()) ||
      (diff < 86400  && t("x-hours-other", {count: Math.floor(diff / 3600)}).ago() )
  } else {
    return (day_diff === 1 && t("x-days-one").ago()) ||
      (day_diff < 31 && t("x-days-other", {count: day_diff}).ago()) ||
      (day_diff < 60 && t("x-months-one").ago()) ||
      (day_diff < 365 && t("x-months-other", {count: Math.floor(day_diff / 30)}).ago()) ||
      (day_diff < 730 && t("x-years-one").ago()) ||
      t("x-years-other", {count: Math.floor(day_diff / 365)}).ago()
  }
};

($.fn as any).prettierDate = function() {
  this.each(function(_idx: number, el: Element){
    const self = el as Element
    const date = prettierDate(self.getAttribute("title") || "", $(self))
    if (date) { $(self).text(date) }
    return
  })
}
